<template>
  <div class="academic">
    <h1 class="title">·乐团活动</h1>

    <div class="academic-list">
      <ul>
        <li class="active-item">
          <a target="view_window" href="https://mp.weixin.qq.com/s/doXuhalwinlUsdJWDUwlYQ">
            <p class="left">教师进修学院附属小学校管乐团荣获南岸区第十六届中小学艺术节一等奖</p>
            <p class="right">2022-05-26</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MjM5Mjc4NTIxNA==&mid=506059635&idx=1&sn=a72ccafa246880c29c1a83e0c18d3e89&chksm=3d7d8d220a0a0434c58339f5886e0d0f96866c5975b21d212e3642f2ed6955afabe2dd2d027c#rd">
            <p class="left">乐团风采丨"六一"与乐同行，我们的童年不一样！</p>
            <p class="right">2021-06-04</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MjM5Mjc4NTIxNA==&mid=506059496&idx=1&sn=d155a71b82c5847687d3e90d258012cb&chksm=3d7d8cb90a0a05afda51381457bc1d2eb0751b1e860c511162ea0ca13968a866b4ca62ae5306#rd">
            <p class="left">第六届“羊城学校美育节”传喜讯，大雅乐盟七所合作学校获奖！</p>
            <p class="right">2021-04-19</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MjM5Mjc4NTIxNA==&mid=506059451&idx=1&sn=eca15816edd52d34a0544c11633e1275&chksm=3d7d8cea0a0a05fcaa73617c382f23b9b7017f3eb8563a584d186f5cf87ac1a9576dd45c6742#rd">
            <p class="left">献礼百年，“艺”展风采 ，罗阳第五小学管乐团艺术展演荣获一等奖！</p>
            <p class="right">2021-04-13</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MjM5Mjc4NTIxNA==&mid=506059227&idx=1&sn=0dc92693486df241bf5605fb794be7a2&chksm=3d7d8f8a0a0a069c885f797312f3531a84cab4d68c55472bed55f932812061d6353581b5d7fc#rd">
            <p class="left">树信心、养习惯——石家庄保利启新小学、跃进路小学管乐团上交月度学习报告啦！</p>
            <p class="right">2021-04-02</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MjM5Mjc4NTIxNA==&mid=506059219&idx=1&sn=2ff0547ae419e9f6e45dbbc0cecba501&chksm=3d7d8f820a0a06947c3dfd355800e44a8c5a34ce47603effb1409aefa42e36274cbbd527bd7b#rd">
            <p class="left">沈阳铁路第五小学管乐团奏响新学期的第一首乐曲</p>
            <p class="right">2021-03-04</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MjM5Mjc4NTIxNA==&mid=506059063&idx=1&sn=3bc2bcf42990ac118562a182c6a721e0&chksm=3d7d8f660a0a067061ebfa7b2661f11d3beb653586ff3e690c0885b44bbb67d1ff07bb9a3998#rd">
            <p class="left">尊重教育，建优质教师团队，做示范乐团</p>
            <p class="right">2021-01-29</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MjM5Mjc4NTIxNA==&mid=506058984&idx=1&sn=3b787be16ca43047fdfce6706c91507d&chksm=3d7d8eb90a0a07af27b56f509f84e4f8ad36a711f1ecabef7102a948590693ffd5de73568e00#rd">
            <p class="left">在管乐团里能收获什么？看看武汉瑞景小学童心管乐团上交的“成绩单”</p>
            <p class="right">2021-01-12</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="https://mp.weixin.qq.com/s/oq_yB5PjCsSAbbvpOnb14w">
            <p class="left">逐梦前行，斩获殊荣——贵阳市中小学乐团大赛传喜讯</p>
            <p class="right">2020-11-18</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="https://mp.weixin.qq.com/s/TzzXH1b3pN46PSCYqkpKcg">
            <p class="left">筑牢教学生命线，“线上复课”谱新篇——大雅乐盟开启“云乐团”课堂</p>
            <p class="right">2020-05-29</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="https://mp.weixin.qq.com/s/giqfGsZyQxQy_ay1g2os9g">
            <p class="left">万千星辉·璀璨之夜——无锡大雅乐盟管乐团闪耀华东少儿春晚</p>
            <p class="right">2020-01-22</p>
          </a>
        </li>

        <li class="active-item">
          <a target="view_window" href="https://mp.weixin.qq.com/mp/homepage?__biz=MjM5Mjc4NTIxNA==&hid=3&sn=fd5e9c9ed920ff624b6797216150b136&scene=18">
            <p class="left">大雅乐盟往期乐团活动</p>
            <!-- <p class="right">2017-12-12</p> -->
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less" scoped>
.academic {
  padding: 0 32px;
  min-height: 500px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);
  .title {
    position: relative;
    padding: 20px 0;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
    font-weight: bold;
    &:after {
      content: "";
      height: 5px;
      width: 100%;
      background: rgba(20, 146, 138, 1);
      z-index: 10;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    // padding: 25px 0 20px;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
  }

  .academic-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    padding-bottom: 149px;
    ul {
      display: block;
      width: 100%;
      .active-item {
        display: block;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid #cecece;

        a {
          text-decoration: none;
          color: #4a4a4a;
          cursor: pointer;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: nowrap;
          .right {
            width: 100px;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(74, 74, 74, 1);
            text-align: right;
          }
          &:hover {
            color: #14928a;
          }
        }
      }
    }

    .acadmic-item {
      margin: 0 24px 20px;
      flex: 0 0 250px;
      box-shadow: 6px 2px 20px 0px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      img {
        width: 250px;
        height: 354px;
      }
      p {
        width: 250px;
        line-height: 42px;
        padding: 0 8px;
        color: #444;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
  }
}
</style>

<script>
export default {
  name: "academic",
  data() {
    return {};
  },
};
</script>
